<script lang="ts">
  /* An empty screen is an invitation to act, not a shrug.
   *
   * It says what is not there, what to do about it, and offers the control that
   * does it. "No trips yet" on its own is a state; "No trips yet — tap two
   * points on the chart and the router will time the narrows between them" is a
   * way in.
   *
   * The same rule the layers panel follows for an unavailable row: absence is a
   * fact, and a fact is something you write down.
   */
  import type { Snippet } from 'svelte';

  let {
    title,
    /** One sentence, in the interface's voice. No apologies — an empty list is
     *  not an error and must not read like one. */
    body,
    /** The way out. A single button, usually the same primary action the
     *  panel's foot would carry once there is something to act on. */
    action
  }: { title: string; body: string; action?: Snippet } = $props();
</script>

<div class="empty">
  <span class="t">{title}</span>
  <p>{body}</p>
  {#if action}{@render action()}{/if}
</div>

<style>
  .empty {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--sp-4);
    padding: var(--sp-7) var(--sp-5);
  }
  .t {
    font: var(--fs-label) / 1 var(--px);
    letter-spacing: var(--tr-label);
    color: var(--sub);
    text-transform: uppercase;
  }
  p {
    margin: 0;
    font: var(--fs-read) / var(--lh-read) var(--sans);
    color: var(--sub);
    /* Measure, not width. A line of prose past about 45 characters in a 360 px
       panel is harder to come back to than one that wraps. */
    max-width: 34ch;
  }
</style>
